// Consultation Scheduler Component
// Allows users to schedule a free consultation

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';

const ConsultationScheduler = ({
  selectedConsultDate,
  setSelectedConsultDate,
  availableSlots,
  selectedSlot,
  setSelectedSlot,
  fetchAvailableSlots,
  handleScheduleConsultation,
  onSkip
}) => {
  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" className="flex-1 justify-start" data-testid="select-date-btn">
              <CalendarIcon className="w-4 h-4 mr-2" />
              {selectedConsultDate ? format(selectedConsultDate, 'MMM d, yyyy') : 'Select date'}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={selectedConsultDate}
              onSelect={(date) => {
                setSelectedConsultDate(date);
                if (date) fetchAvailableSlots(date);
              }}
              disabled={(date) => date < new Date()}
            />
          </PopoverContent>
        </Popover>
      </div>
      
      {availableSlots.length > 0 && (
        <Select value={selectedSlot} onValueChange={setSelectedSlot}>
          <SelectTrigger data-testid="select-time">
            <SelectValue placeholder="Select time" />
          </SelectTrigger>
          <SelectContent>
            {availableSlots.map((slot) => (
              <SelectItem key={slot.time} value={slot.time}>
                {slot.time}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          className="flex-1"
          onClick={onSkip}
          data-testid="skip-schedule-btn"
        >
          Skip for now
        </Button>
        <Button 
          className="flex-1 bg-teal-500 hover:bg-teal-600"
          onClick={handleScheduleConsultation}
          disabled={!selectedConsultDate || !selectedSlot}
          data-testid="confirm-schedule-btn"
        >
          Schedule
        </Button>
      </div>
    </div>
  );
};

export default ConsultationScheduler;
